import { Trans } from "@lingui/react/macro";
import { selectors } from "@ReduxStore/reducers";
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import { PRIVACY_URL, ROUTES } from "@Src/constants";
import FooterProgramInfo from "./FooterProgramInfo";
import FooterTeaserNav from "./FooterTeaserNav";
import TermlyPreferences from "../Termly/TermlyPreferences";
import { SkipToHere } from "@Src/components/SkipToContent";

import "./Footer.scss";

const { getProgram, getIsStandaloneTravel } = selectors;

function Footer(props) {
  const isChatEnabled = process.env.REACT_APP_CHAT_ENABLED === "true";
  const isProduction = process.env.REACT_APP_ENV === "production";

  return (
    <SkipToHere contentId="FooterContent">
      <footer className="Footer">
        <div className="Footer-userNav">
          {!props.isStandaloneTravel && <FooterTeaserNav program={props.program} />}
          <FooterProgramInfo program={props.program} />
          <div className={`Footer-bottomNavLinks${isChatEnabled ? " Footer-withchat" : ""}`}>
            <ul className="Footer-bottomNavUl t-label-large">
              <li>
                <Link to={ROUTES.TERMS_PATH}>
                  <Trans>Terms of Use</Trans>
                </Link>
              </li>
              <li>
                <a href={PRIVACY_URL} rel="noopener noreferrer" target="_blank">
                  <Trans>Privacy Policy</Trans>
                </a>
              </li>
              {isProduction && (
                <li>
                  <TermlyPreferences />
                </li>
              )}
              <li>
                <Link to={ROUTES.HELP_PATH}>
                  <Trans>Contact Us</Trans>
                </Link>
              </li>
              <li>
                <Link to={ROUTES.DEALS_FAQ}>
                  <Trans>FAQ</Trans>
                </Link>
              </li>
              <li>&copy;{new Date().getFullYear()}, Access Development</li>
            </ul>
          </div>
        </div>
      </footer>
    </SkipToHere>
  );
}

const mapStateToProps = (state) => ({
  program: getProgram(state),
  isStandaloneTravel: getIsStandaloneTravel(state),
});

export default connect(mapStateToProps)(Footer);
